import request from '@/utils/request'

const api = {
  pageQuery: "/avt/pageQuery",
  deleteInfo: "/avt/deleteInfo",
  save: "/avt/save",
  detail:"/avt/detail",
  updateStatus:"/avt/updateStatus",
  queryhomeTop:"/avt/queryAvt",
  regionSave: "/region/save",
  regionDelete: "/region/deleteInfo"
}

export default api

export function addRegion(data){
  return request({
    url: api.regionSave,
    method: 'post',
    data
  })
}

export function delRegion(data){
  return request({
    url: api.regionDelete,
    method: 'post',
    data
  })
}

export function pageQuery(data){
  return request({
    url: api.pageQuery,
    method: 'post',
    data
  })
}

export function deleteInfo(data){
  return request({
    url: api.deleteInfo,
    method: 'post',
    data
  })
}

export function save(data){
  return request({
    url: api.save,
    method: 'post',
    data
  })
}

export function detail(data){
  return request({
    url: api.detail,
    method: 'post',
    data
  })
}

export function updateStatus(data){
  return request({
    url: api.updateStatus,
    method: 'post',
    data
  })
}

export function queryhomeTop(data){
  return request({
    url: api.queryhomeTop,
    method: 'post',
    data
  })
}
